import {useDimensions} from '../../contexts/dimensions/use-dimensions'
import {FullWidthNavBar} from './components/full-width/full-width-nav-bar'
import {HamburgerNavBar} from './components/hamburger/hamburger-nav-bar'

import type {JSX} from 'react'

export function Navigation(): JSX.Element {
    const {width} = useDimensions()
    return width < 1300 ? <HamburgerNavBar /> : <FullWidthNavBar />
}
